import ImageTokenStore from './ImageTokenStore';

export default {
  install(store) {
    if (!store.state.base) {
      store.registerModule(['base'], {
        state: {},
      });
    }
    if (!store.state.base.ImgToken) {
      store.registerModule(['base', 'ImgToken'], ImageTokenStore);
    }
  },
  uninstall(store) {
    store.unregisterModule(['base', 'ImgToken']);
  },
};
